import { map } from 'lodash';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { TimeOfDay, TimeOfDaySelectOption } from './time-of-day';

export const getTimeOfDaySelectOptions: () => TimeOfDaySelectOption[] = () =>
  map(TimeOfDay).map((timeOfDay) => ({
    value: timeOfDay,
    label: translate(translationKeys.common.timeOfDay[timeOfDay]),
  }));
